/**
 * Cookiebeleid — Fase 2 (ePrivacy / AVG-transparantie).
 */
import { Link } from 'react-router-dom';
import { AnimatedSection } from '../components/AnimatedSection';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { SeoMeta } from '../components/SeoMeta';

const LAST_UPDATED = '25 maart 2026';

export function Cookies() {
  return (
    <div className="animate-page-enter">
      <SeoMeta
        path="/cookies"
        title="Cookies"
        description="Cookiebeleid CalqTool™: welke cookies en vergelijkbare technieken we gebruiken, waarom, en hoe je voorkeuren kunt beheren — transparant en AVG-conform."
      />
      <AnimatedSection delay={0.05}>
        <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Cookies' }]} />
        <h1 className="mb-6 text-2xl font-bold text-text">Cookies en vergelijkbare technieken</h1>
        <div className="max-w-3xl space-y-6 rounded-lg border border-border bg-surface-card p-6">
          <p className="text-sm text-text-muted">Laatst bijgewerkt: {LAST_UPDATED}</p>

          <section>
            <h2 className="mb-2 font-semibold text-text">1. Wat zijn cookies?</h2>
            <p className="text-sm text-text-muted">
              Cookies zijn kleine tekstbestanden die op uw apparaat worden geplaatst. Wij gebruiken alleen wat nodig is
              voor de werking van de site en — als u daarvoor kiest — voor anonieme gebruiksstatistiek via onze eigen
              server (geen Google Analytics of vergelijkbare externe marketingpixels in de standaardconfiguratie).
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-semibold text-text">2. Noodzakelijke cookies en opslag</h2>
            <p className="text-sm text-text-muted">
              Deze zijn nodig om CalqTool te laten werken en vallen onder gerechtvaardigd belang / uitvoering van de
              overeenkomst:
            </p>
            <ul className="mt-2 list-inside list-disc space-y-1 text-sm text-text-muted">
              <li>
                <strong className="text-text">Sessie / authenticatie:</strong> bijvoorbeeld een token na inloggen
                (lokale opslag en/of cookies, afhankelijk van uw browserinstellingen) om u ingelogd te houden. Een
                sessie op de server kan tot ongeveer <strong className="text-text">30 dagen</strong> geldig blijven
                tenzij u eerder uitlogt; ter beveiliging kan de webapp u na{' '}
                <strong className="text-text">ongeveer 45 minuten zonder activiteit</strong> (geen typen, klikken of
                vergelijkbare interactie) automatisch afmelden — ook op een gedeelde computer. Zie ook het{' '}
                <Link to="/privacy" className="font-medium text-primary hover:underline">
                  privacybeleid
                </Link>
                .
              </li>
              <li>
                <strong className="text-text">Assistent-thread (optioneel):</strong> tijdelijke referenties in de browser
                om uw chatgesprek voort te zetten.
              </li>
              <li>
                <strong className="text-text">Technische voorkeuren:</strong> zoals uw keuze in deze cookiebanner
                (lokale opslag).
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 font-semibold text-text">3. Statistiek (analytics) — alleen met toestemming</h2>
            <p className="text-sm text-text-muted">
              Als u <strong className="text-text">“Sta analytics toe”</strong> kiest, sturen wij anonieme gebeurtenissen
              naar onze eigen API (bijv. paginaweergaves, sommige productacties). Gegevens gaan naar servers die door
              CalqTool worden beheerd, niet naar advertentienetwerken. Zonder deze keuze worden deze events niet
              verstuurd.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-semibold text-text">4. Uw keuze wijzigen</h2>
            <p className="text-sm text-text-muted">
              Via <strong className="text-text">Cookievoorkeuren</strong> in de footer kunt u uw eerdere keuze wissen;
              de banner verschijnt dan opnieuw. U kunt ook zelf gegevens in de browser wissen (let op: dan bent u
              meestal uitgelogd). Handmatig uitloggen of automatische afmelding na inactiviteit beëindigt de actieve
              sessie in de app.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-semibold text-text">5. Meer informatie</h2>
            <p className="text-sm text-text-muted">
              Zie ook het{' '}
              <Link to="/privacy" className="font-medium text-primary hover:underline">
                privacybeleid
              </Link>{' '}
              en de{' '}
              <Link to="/terms" className="font-medium text-primary hover:underline">
                algemene voorwaarden
              </Link>
              .
            </p>
          </section>

          <Link to="/" className="inline-flex text-primary transition-colors duration-200 hover:underline">
            ← Terug naar home
          </Link>
        </div>
      </AnimatedSection>
    </div>
  );
}
